export const sensitivity = ["low", "medium", "high"];
